export default __webpack_public_path__ + "static/media/production_signup.84db33ef.png";